import { Link } from 'react-router-dom';
import { getNewMovies, MovieItem } from '@/mocks/movies';

export default function LatestUpdates() {
  const newMovies = getNewMovies();

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">牛牛影视每日更新，精彩不容错过</p>
          </div>
          <div className="flex items-center gap-2">
            <Link
              to="/category/movie"
              className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              电影
            </Link>
            <span className="text-foreground-300">|</span>
            <Link
              to="/category/tv"
              className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              电视剧
            </Link>
            <span className="text-foreground-300">|</span>
            <Link
              to="/category/anime"
              className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              动漫
            </Link>
            <span className="text-foreground-300">|</span>
            <Link
              to="/category/variety"
              className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              综艺
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop="">
          {newMovies.map((movie: MovieItem) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
                <img
                  src={movie.image}
                  alt={movie.title}
                  title={`${movie.title} - 牛牛极清在线观看`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-accent-500 text-foreground-950 text-xs rounded-md font-medium">
                    更新
                  </span>
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className="px-2 py-0.5 bg-black/60 text-white text-xs rounded-md">
                    {movie.episodes}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {movie.title}
              </h3>
              <p className="text-xs text-primary-500 mt-1">{movie.updateInfo}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}